import {Controller} from "@hotwired/stimulus"
import JustValidate from "just-validate"

export default class extends Controller {
    connect() {
        console.log("Form validation controller connected")
        this.initValidation()
    }

    disconnect() {
        if (this.validator) {
            this.validator.destroy()
        }
    }

    initValidation() {
        this.validator = new JustValidate(this.element, {
            focusInvalidField: true,
            lockForm: true,
        })

        this.validator
            .addField('[name="first_name"]', [
                {
                    rule: 'required',
                    errorMessage: 'First name is required'
                },
                {
                    rule: 'minLength',
                    value: 2,
                    errorMessage: 'First name must be at least 2 characters'
                }
            ])
            .addField('[name="last_name"]', [
                {
                    rule: 'required',
                    errorMessage: 'Last name is required'
                },
                {
                    rule: 'minLength',
                    value: 2,
                    errorMessage: 'Last name must be at least 2 characters'
                }
            ])
            .addField('[name="email"]', [
                {
                    rule: 'required',
                    errorMessage: 'Email is required'
                },
                {
                    rule: 'email',
                    errorMessage: 'Please enter a valid email address'
                }
            ])
            .onSuccess((event) => {
                this.handleSuccess(event)
            })
            .onFail((fields) => {
                this.handleFail(fields)
            })
    }

    handleSuccess(event) {
        console.log('Form is valid, submitting...')
        // Handle successful validation here
    }

    handleFail(fields) {
        console.log('Form validation failed:', fields)
        // Handle validation errors if needed
    }

    submitForm() {
        // Example AJAX submission
        const formData = new FormData(this.element)

        fetch(this.element.action || window.location.href, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data)
                // Handle success response
            })
            .catch(error => {
                console.error('Error:', error)
                // Handle error
            })
    }
}